<template>

<div class="row">

  <div class="col-lg-7 col-sm-6 col-xs-12">
    <panel-block
      :filter="true && typeof currentTask !== 'object'"
      :data="tasks"
      primaryKey="pk"
      :searchFields="[
        'ckay',
        'pk',
        'cycle',
        'timestamp',
        'last',
        'id',
        'origTitle',
        'title',
        'type'
      ]"
      v-on:matches="filterMatches('Tasks', $event)"
    >
      <h2 slot="title">
        Tasks<span v-if="currentTask"> - <a class="text-danger" v-on:click="getTasks()"><i class="fa fa-times"> </i></a> - {{ currentTask.title }}</span>
      </h2>
      <div slot="content">
        <div class="row table-row hidden-xs hidden-sm hidden-md">
          <div class="col-md-4">
            <div class="row">
              <div 
                v-on:click="setSortColumn('id')"
                class="col-md-2"
                style="cursor:pointer;"
              >
                <i 
                  v-if="sort.column === 'id'" 
                  :class="[
                    'fa',
                    'fa-sort-' + sort.direction
                  ]"
                ></i>
                <i 
                  v-else
                  :class="[
                    'fa fa-sort',
                  ]"
                ></i>
                <strong>#</strong> 
              </div>
              <div 
                v-on:click="setSortColumn('title')"
                style="cursor:pointer;"
                class="col-md-4"
              >
                <i 
                  v-if="sort.column === 'title'" 
                  :class="[
                    'fa',
                    'fa-sort-' + sort.direction
                  ]"
                ></i>
                <i 
                  v-else
                  :class="[
                    'fa fa-sort',
                  ]"
                ></i>
                <strong>Name</strong>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="row">
              <div 
                v-on:click="setSortColumn('status')"
                style="cursor:pointer;"
                class="col-md-3"
              >
                <i 
                  v-if="sort.column === 'status'" 
                  :class="[
                    'fa',
                    'fa-sort-' + sort.direction
                  ]"
                ></i>
                <i 
                  v-else
                  :class="[
                    'fa fa-sort',
                  ]"
                ></i>
                <strong>Status</strong>
              </div>
              <div
                v-on:click="setSortColumn('next')"
                style="cursor:pointer;"
                class="col-md-4"
              >
                <i 
                  v-if="sort.column === 'next'" 
                  :class="[
                    'fa',
                    'fa-sort-' + sort.direction
                  ]"
                ></i>
                <i 
                  v-else
                  :class="[
                    'fa fa-sort',
                  ]"
                ></i>
                <strong>Next Run</strong>
              </div>
              <div class="col-md-2">
                <strong>Run</strong>
              </div>
              <div class="col-md-1"></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div v-if="tasks" class="col-xs-12 table-striped">
            <div class="row" v-if="(!currentTask || task.pk == currentTask.pk)" v-for="task in filteredTasks" v-bind:class="[ ( currentLogTask && currentLogTask.pk !== task.pk) ? 'hidden-xs' : '' ]">
              <div class="col-lg-4 col-xs-8">
                <div class="row">
                  <div class="col-xs-2">
                    <strong>{{ task.id }}</strong>
                  </div>
                  <div class="col-xs-10">
                    {{ task.title }}
                    <br>
                    <small>{{ task.last | moment("calendar") }}</small>
                  </div>
                  <div class="col-xs-10 col-xs-offset-2 hidden-lg">
                    <p><br /><span class="hidden-lg"><strong>Next Run:</strong><br /> </span><small>{{ task.next | moment("calendar") }}</small></p>
                  </div>
                </div>
              </div>

              <div class="col-lg-8 col-xs-4">
                <div class="row">
                  <div class="col-lg-3 col-xs-12 hidden-xs" style="margin-bottom: 5px;" >
                    <dropdown :text="statusList[task.status].title" class="btn-block" size="sm" :type="statusList[task.status].style">
                      <li class="btn-block" v-for="status in statusList"><button class="btn-block btn-link" v-on:click.prevent="changeTaskStatus(task, status)" >{{ status.title }}</button></li>
                    </dropdown>
                  </div>

                  <div class="col-lg-4 hidden-xs hidden-sm hidden-md">
                    <p v-if="task.status == 1">{{ task.next | moment("calendar") }}</p>
                  </div>

                  <div class="col-xs-12 hidden-sm hidden-md hidden-lg" style="margin-bottom: 5px;">
                    <dropdown :text="statusList[task.status].title" class="btn-block" size="sm" :type="statusList[task.status].style">
                      <li class="btn-block" v-for="status in statusList"><button class="btn-block btn-link" v-on:click.prevent="changeTaskStatus(task, status)">{{ status.title }}</button></li>
                    </dropdown>
                  </div>

                  <div class="col-lg-3 col-xs-12">
                    <button 
                      v-if="task.status !== '0'" 
                      v-on:click.prevent="taskRunConfirmation(task)" 
                      class="btn btn-default btn-sm btn-block"
                      v-html="
                        typeof runningTask === 'object' && runningTask.pk === task.pk ? 'Running' : 'Run Now'
                      "
                    > 
                    </button>
                  </div>
                  <div class="col-lg-2 col-xs-12">
                    <button type="button" v-if="currentLogTask.pk != task.pk" v-on:click="getLogs(task)" class="btn btn-block btn-warning btn-sm">Log</button>
                    <button type="button" v-if="currentLogTask.pk == task.pk" v-on:click="getLogs()" class="btn btn-block btn-danger btn-sm">Clear</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center" v-else><i class="fa fa-4x fa-spin fa-spinner loader"> </i></div>
        </div>
      </div>
    </panel-block>
  </div>

  <div class="col-lg-5 col-sm-6 col-xs-12">
    <panel-block
      :filter="true && typeof currentLogTask !== 'object'"
      :data="log"
      primaryKey="pk"
      v-on:matches="filterMatches('Logs', $event)"
    >

      <h2 slot="title">
        Task Log<span v-if="currentLogTask"> - <a class="text-danger" v-on:click="getLogs()"><i class="fa fa-times"> </i></a> - {{ currentLogTask.title }}</span>
      </h2>
      <div slot="content">

        <div class="row table-row hidden-xs hidden-sm hidden-md">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-lg-10 col-xs-10">
                <div class="row">
                    <div class="col-xs-1"><strong>#</strong></div>
                    <div class="col-lg-6 col-xs-8"><strong>Name</strong></div>
                    <div class="col-lg-5"><strong>Run Times</strong></div>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-xs-2">
                <div class="col-md-2"></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div v-if="log.length > 0 && tasks.length > 0" class="col-xs-12 table-striped">
            <div class="row" v-for="item in filteredLogs">
              <div class="col-lg-10 col-xs-10">
                <div class="row">
                  <div class="col-lg-1 col-xs-1"><strong>{{ !currentLogTask ? item.id : currentLogTask.id }}</strong></div>
                  <div class="col-lg-6 col-xs-8">
                    {{ !currentLogTask ? item.title : currentLogTask.title }}
                  </div>
                  <div class="col-lg-5 col-lg-offset-0 col-xs-8 col-xs-offset-1">
                    <br class="hidden-lg" />
                    {{ item.start | moment("MMM DD") }} &mdash; <strong>{{ item.dur }}&nbsp;Second</strong>
                    <br />
                    {{ item.start | moment("hh:mm:ss") }} &mdash; {{ item.end | moment("hh:mm:ss A") }}
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-xs-2">
                <div class="row">
                  <div class="col-lg-12">
                    <button v-if="!currentLogTask" v-on:click.prevent="getLogs(item)" class="btn btn-default btn-sm"><i class="fa fa-filter"></i></button>
                    <button v-if="currentTask.pk !== item.pk" v-on:click.prevent="getTasks(item)" class="btn btn-primary btn-sm"><i class="fa fa-search"></i></button>
                    <button v-if="currentTask.pk === item.pk" v-on:click.prevent="getTasks()" class="btn btn-danger btn-sm"><i class="fa fa-times"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center" v-else><i class="fa fa-4x fa-spin fa-spinner loader"> </i></div>
        </div>

      </div>
    </panel-block>
  </div>

  <div
    :class="[
      'modal fade bs-example-modal-sm',
      displayModal ? 'in visible-lg-block visible-md-block visible-sm-block visible-xs-block' : 'hidden-xs'
    ]"
    tabindex="-1" role="dialog" aria-hidden="true" 
    style="padding-right: 15px;">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">

        <div class="modal-header">
          <button 
            type="button"
            class="close"
          >
            <span
              v-on:click="clearCurrentRunningTask()"
            >×</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">{{ runningTask.id }}: {{runningTask.title }}</h4>
        </div>
        <div class="modal-body">
          <p><strong>Next:</strong> {{ runningTask.next | moment("calendar")}}</p>
          <p><strong>Last:</strong> {{ runningTask.last | moment("calendar")}}</p>
          <h4>Are you Sure?</h4>
        </div>
        <div class="modal-footer">
          <button
            v-on:click.prevent="clearCurrentRunningTask()"
            type="button"
            class="btn btn-default"
          >
            Cancel
          </button>
          <button
            v-on:click.prevent="runTaskNow(runningTask)"
            type="button"
            class="btn btn-primary"
          >
            Run Now
            </button>
        </div>

      </div>
    </div>
  </div>


</div>
</template>
<script>
import { dropdown } from 'vue-strap'
import { mapActions } from 'vuex'

import Panel from '@/components/Layout/Panel.vue'

export default {
  name: 'tasklog',
  components: {
    dropdown,
    'panel-block': Panel
  },
  data () {
    return {
      tasks: [],
      runningTask: '',
      sort: {
        column: 'id',
        direction: 'desc'
      },
      log: [],
      displayModal: false,
      pageTitle: 'test',
      currentLogTask: '',
      currentTask: '',
      statusList: [
        { pk: 0, title: 'Inactive', style: 'default' },
        { pk: 1, title: 'Active', style: 'success' },
        { pk: 2, title: 'Off', style: 'danger' },
        { pk: 3, title: 'On Demand', style: 'info' },
        { pk: 4, title: 'Linked', style: 'warning' },
        { pk: 5, title: 'Linked', style: 'warning' }
      ],
      filteredTasks: [],
      filteredLogs: []
    }
  },
  mounted () {
    this.getTasks()
    this.getLogs()
  },
  methods: {
    ...mapActions([
      'buildApiReqeust',
      'updateUser'
    ]),
    setSortColumn (id) {
      let sortDirection = 'desc'
      if (id === this.sort.column && this.sort.direction === 'desc') {
        sortDirection = 'asc'
      }

      this.$set(this.sort, 'column', id)
      this.$set(this.sort, 'direction', sortDirection)
      let items = this.sortTaskList(this.filteredTasks)
      this.$set(this, 'filteredTasks', items)
    },
    filterMatches (type, items) {
      if (type === 'Tasks') {
        items = this.sortTaskList(items)
      }
      this.$set(this, 'filtered' + type, items)
    },
    sortTaskList (items) {
      let list = JSON.parse(JSON.stringify(items))
      let key = this.sort.column
      return list.sort((a, b) => {
        if (this.sort.direction === 'desc') {
          return (a[key] > b[key]) - (a[key] < b[key])
        }
        return (a[key] < b[key]) - (a[key] > b[key])
      })
    },
    changeTaskStatus (task, newStatus) {
      this.$task(task)
        .set('status', newStatus.pk)
        .save()
        .then(response => {
          // console.log(response)
          // this.getTasks()
        })
    },
    clearCurrentRunningTask () {
      this.$set(this, 'runningTask', '')
      this.$set(this, 'displayModal', false)
    },
    taskRunConfirmation (task = null) {
      this.$set(this, 'runningTask', task)
      this.$set(this, 'displayModal', true)
    },
    runTaskNow (task) {
      this.$set(this, 'displayModal', false)
      this.$task(task).run().then(response => {
        if (response.data.Function.success === false) {
          this.$set(this, 'displayModal', false)
          this.$set(this, 'runningTask', task)
          return false
        }
        this.$set(this, 'runningTask', '')
        this.$set(this, 'displayModal', false)
        this.getLogs()
      })
    },
    toggleLogsListDisply () {
      this.showLogs = (this.showLogs ? 0 : 1)
    },
    getLogs (item = null) {
      this.$set(this, 'log', [])
      this.currentLogTask = ''
      if (item !== null) {
        this.$set(this, 'currentLogTask', item)
        this.$task(item).log().then(response => {
          let logs = this.parseLogs(response)
          this.$set(this, 'log', logs)
        })
        .catch(e => {
          console.log(e)
        })
        return false
      }

      this.$log('task').all().then(response => {
        let logs = this.parseLogs(response)
        this.$set(this, 'log', logs)
      })
    },
    parseLogs (response, pk = null) {
      return this.attachLogItem(response)
    },
    attachLogItem (item, pk) {
      if (typeof item === 'object' && typeof item[0] === 'object') {
        for (let i = 0; item.length > i; i++) {
          item[i] = this.attachLogItem(item[i], pk)
        }
        return item
      }

      item.pk = pk
      if (pk === null) {
        let regex = /\(([A-Z0-9]{2,3})\)\s?(.*)/
        let matches = regex.exec(item.title)
        if (matches === null) {
          return item
        }
        try {
          item.pk = this.getTaskByTitle(item.title).pk
          item.id = matches[1]
          item.title = matches[2]
        } catch (e) {
          console.log(e)
        }
      }
      return item
    },
    getTasks (task = null) {
      return new Promise((resolve, reject) => {
        if (task !== null) {
          let pk = task.pk !== null ? task.pk : task.task_pk
          this.$set(this, 'currentTask', this.getTaskByPk(pk))
          return false
        }
        this.$set(this, 'currentTask', '')
        this.$task().all().then(response => {
          this.parseTasks(response)
          resolve()
        })
      })
    },
    parseTasks (response = null) {
      let tasks = response
      let newList = response

      for (let i = 0; tasks.length > i; i++) {
        let regex = /\(([A-Z0-9]{2,3})\)\s?(.*)/
        let matches = regex.exec(tasks[i].title)
        if (matches === null) {
          continue
        }
        try {
          newList[i].origTitle = tasks[i].title
          newList[i].id = (matches[1] ? matches[1] : '')
          newList[i].title = (matches[2] ? matches[2] : '')
          newList[i].runtime = (matches[3] ? matches[3] : '')
        } catch (e) {
          console.log(e)
          continue
        }
      }
      this.$set(this, 'tasks', newList)
    },
    getTaskByTitle (title) {
      for (let i = 0; this.tasks.length > i; i++) {
        if (this.tasks[i].origTitle === title) {
          return this.tasks[i]
        }
      }
    },
    getTaskByPk (pk) {
      for (let i = 0; i < this.tasks.length; i++) {
        if (this.tasks[i].pk === pk) {
          return this.tasks[i]
        }
      }
    },
    hhmmss (seconds) {
      let minutes = Math.floor(seconds / 60)
      let hours = Math.floor(minutes / 60)

      minutes = minutes % 60
      seconds = seconds % 60
      let time = ''
      if (hours !== 0) { time += hours + ':' }
      if (minutes < 10 && minutes !== 0) { time += '0' + minutes + ':' }
      if (seconds < 10 && seconds !== 0) { time += '0' + seconds }

      return time
    }
  },
  watch: {
    log () {
      if (this.tasks.length === 0) {
        return false
      }
      this.attachLogItem(this.log, null)
    },
    tasks () {
      if (this.log.length === 0) {
        return false
      }
      this.attachLogItem(this.log, null)
    }

  }
}

</script>

<style>
.table-row > div {
  padding-top: 8px;
  padding-bottom: 8px;
}
.table-striped > .row {
  padding-top: 8px;
  padding-bottom: 8px;
  border-top: 1px solid #ddd;
}
.table-striped > .row:nth-child(odd){
  background-color: #f9f9f9;
}
div.btn-block > button {
  display: block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Tasklog.vue?21b80fe4